/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-param-reassign, max-len */
import React from 'react';
import {
  Paper, Tooltip,
  Popover,
} from '@mui/material';

import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

import {
  MdCallMade, MdMail, MdShare,
} from 'react-icons/md';
import { BsBookmarkXFill } from 'react-icons/bs';
import { CloseIcon } from 'src/icons';
import { SendMail } from 'src/components';
import { useApplyJob } from 'src/hooks/query/jobs';
import { useShareProfiles } from 'src/hooks/query/shareProfiles';
import { useSendBulkMail } from 'src/hooks/query/mailMerge';
import { SendMailFormValues } from 'src/components/SendMail';

import { TalentPoolCandidateRecord, TalentPoolViewRendererProps } from '../../types';

import {
  ApplyToJobForm, TalentPoolFilters,
  TalentPoolTable, ShareProfileForm,
} from '../../components';
import { ApplyJobFormValues } from '../../components/ApplyToJobForm';
import { ShareProfileFormValues } from '../../components/ShareProfileForm';

function Desktop(props: TalentPoolViewRendererProps) {
  const {
    onRowSelectionChange, rowSelection, onChangePagination, filters,
    records, profilesFetching, onRowClick, onApplyFilter, onFiltersReset,
    bookmarkProfile, bookmarkedRecords, bookmarksFetching, onAfterJobApply,
  } = props;
  const { isPending, applyJob } = useApplyJob();
  const { shareProfiles, shareProfilesPending } = useShareProfiles();
  const { sendMail, mailSending } = useSendBulkMail();

  const [openBookmarks, setOpen] = React.useState(false);

  const selectedMultipleCandidates = Object.keys(rowSelection).length >= 2;

  const [applyJobAnchorEl, setApplyJobAnchorEl] = React.useState<HTMLElement | null>(null);
  const [
    mailmergeAnchorEl, setMailmergeAnchorEl,
  ] = React.useState<HTMLElement | null>(null);
  const [
    shareProfileAnchorEl, setShareProfileAnchorEl,
  ] = React.useState<HTMLElement | null>(null);

  const handleApplyToJobFormSubmit = async (data: ApplyJobFormValues) => {
    // Object.keys(rowSelection).map((index: string) => records[index]);
    const canidateIds = Object.keys(rowSelection).map((key: string) => records[Number(key)])
      .map((record) => Number(record.candidateId));
    try {
      await applyJob({
        candidateIds: [...canidateIds],
        jobOrderId: data.jobId,
      });
      onAfterJobApply();
      setApplyJobAnchorEl(null);
    } catch (e) {
      console.log(e);
    }
  };

  const handleShareProfilesFormSubmit = async (data: ShareProfileFormValues) => {
    // Object.keys(rowSelection).map((index: string) => records[index]);
    const canidateIds = Object.keys(rowSelection).map((key: string) => records[Number(key)])
      .map((record) => Number(record.candidateId));
    try {
      await shareProfiles({
        candidateIds: [...canidateIds],
        toList: data.emails.join(','),
        comments: data.comments,
      });
      onAfterJobApply();
      setShareProfileAnchorEl(null);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSendMailFormSubmit = async (data: SendMailFormValues) => {
    try {
      await sendMail({
        toList: data.to,
        ccList: data.cc || [],
        body: data.content || '',
        subject: data.subject,
        jobOrderId: data.jobOrderId,
      });
      setMailmergeAnchorEl(null);
    } catch (e) {
      console.log(e);
    }
  };

  const emailIds = React.useMemo(
    () => Object.keys(rowSelection)
      .map((key: string) => records[Number(key)])
      .map((record) => record.emailAddress),
    [rowSelection],
  );

  return (
    <div id="parent-container" className="flex">
      <div className="p-10 pt-0 pr-20 w-full">
        <TalentPoolFilters
          onReset={onFiltersReset}
          onSubmit={onApplyFilter}
          defaultValue={filters}
        />
        <Paper className="mb-4 flex items-stretch justify-center mt-2 default-shadow-table overflow-x-hidden">
          <div className="flex-1">
            <TalentPoolTable
              bookmarkProfile={bookmarkProfile}
              onToggleBookmarks={() => setOpen((prev) => !prev)}
              rowSelection={rowSelection}
              onRowSelectionChange={onRowSelectionChange}
              openBookmarks={openBookmarks}
              onChangePagination={onChangePagination}
              pagination={filters.pagination}
              records={records}
              onRowClick={onRowClick}
              profilesFetching={profilesFetching}
              onAfterJobApply={onAfterJobApply}
            />
          </div>
          <AnimatePresence>
            <motion.div
              initial={{ width: 0 }}
              animate={openBookmarks ? 'open' : 'closed'}
              transition={{ duration: 0.3 }}
              variants={{
                open: { opacity: 1, width: 300 },
                closed: { opacity: 0, width: 0 },
              }}
              exit={{
                width: 0,
                transition: { delay: 0.2, duration: 0.3 },
              }}
              className="custom-shadow"
            >
              {bookmarkedRecords && bookmarkedRecords.length > 0 && (
                <div className="p-2 flex flex-col gap-4 max-h-[80vh] overflow-y-auto">
                  {bookmarkedRecords.map((bookmark) => (
                    <div
                      className="flex flex-col cursor-pointer border border-solid border-[#eee] rounded-md items-start p-4 relative"
                      onClick={() => onRowClick({ hashKey: bookmark.hashKey } as TalentPoolCandidateRecord)}
                    >
                      <div>
                        {bookmark.name}
                      </div>
                      <div className="text-xs">
                        {bookmark.emailAddress}
                      </div>
                      <div className="text-xs border py-2">
                        {bookmark.candidateStatus}
                      </div>
                      <Tooltip title="Unbookmark">
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            bookmarkProfile({ candidateId: Number(bookmark.candidateId), isBookMarked: true } as TalentPoolCandidateRecord);
                          }}
                          className="right-2 top-2 absolute border border-solid border-[#ddd] rounded-full p-[4px] flex items-center justify-center cursor-pointer h-6 w-6"
                        >
                          <BsBookmarkXFill className="w-full fill-primary h-full" />
                        </div>
                      </Tooltip>
                    </div>
                  ))}
                </div>
              )}
              {bookmarkedRecords && bookmarkedRecords.length === 0 && (
                <div className="p-2 flex flex-col gap-4">No bookmarks found</div>
              )}
              {bookmarksFetching && <>Loading...</>}
            </motion.div>
          </AnimatePresence>
        </Paper>
        <div className="fixed right-0 top-[35%]">
          <Popover
            open={Boolean(applyJobAnchorEl)}
            anchorEl={applyJobAnchorEl}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            onClose={() => setApplyJobAnchorEl(null)}
          >
            <div className="absolute right-2 top-2" onClick={() => setApplyJobAnchorEl(null)}>
              <CloseIcon className="cursor-pointer" />
            </div>
            <ApplyToJobForm onSubmit={handleApplyToJobFormSubmit} loading={isPending} />
          </Popover>
          <Popover
            open={Boolean(shareProfileAnchorEl)}
            anchorEl={shareProfileAnchorEl}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            onClose={() => setShareProfileAnchorEl(null)}
          >
            <div className="absolute right-2 top-2" onClick={() => setShareProfileAnchorEl(null)}>
              <CloseIcon className="cursor-pointer" />
            </div>
            <ShareProfileForm
              onSubmit={handleShareProfilesFormSubmit}
              loading={shareProfilesPending}
            />
          </Popover>

          <Popover
            open={Boolean(mailmergeAnchorEl)}
            anchorEl={mailmergeAnchorEl}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            onClose={() => setMailmergeAnchorEl(null)}
          >
            <div className="absolute right-2 top-2" onClick={() => setMailmergeAnchorEl(null)}>
              <CloseIcon className="cursor-pointer" />
            </div>
            <div className="w-[600px] flex-shrink-0">
              {Boolean(mailmergeAnchorEl) && (
                <SendMail
                  defaultValues={{
                    to: emailIds,
                    subject: '',
                    content: '',
                    jobOrderId: null,
                  }}
                  loading={mailSending}
                  onSubmit={handleSendMailFormSubmit}
                />
              )}
            </div>
          </Popover>
          <Tooltip
            title={selectedMultipleCandidates ? undefined : 'Select multiple candidates to perform these actions.'}
            placement="left"
            arrow
            classes={{
              popper: 'p-2 text-lg',
              tooltip: 'text-base text-center',
            }}
          >
            <div
              className={twMerge(
                'flex gap-4 !bg-[#282828] p-2 rounded-lg !rounded-r-none custom-shadow flex-col',
                !selectedMultipleCandidates && 'opacity-50 cursor-pointer',
              )}
            >
              <Tooltip title={selectedMultipleCandidates ? 'Apply to' : undefined} placement="left">
                <div
                  className="border border-solid rounded-full border-white cursor-pointer p-1 h-7 w-7"
                  onClick={(e) => (
                    selectedMultipleCandidates ? setApplyJobAnchorEl(e.currentTarget) : null
                  )}
                >
                  <MdCallMade className="w-full text-white h-full" />
                </div>
              </Tooltip>
              <Tooltip title={selectedMultipleCandidates ? 'Mail Merge' : undefined} placement="left">
                <div
                  className="border border-solid border-white rounded-full cursor-pointer p-1 h-7 w-7"
                  onClick={(e) => (
                    selectedMultipleCandidates ? setMailmergeAnchorEl(e.currentTarget) : null
                  )}
                >
                  <MdMail className="w-full text-white h-full" />
                </div>
              </Tooltip>
              <Tooltip title={selectedMultipleCandidates ? 'Share Profiles' : undefined} placement="left">
                <div
                  className="border border-solid border-white rounded-full cursor-pointer p-1 h-7 w-7"
                  onClick={(e) => (
                    selectedMultipleCandidates ? setShareProfileAnchorEl(e.currentTarget) : null
                  )}
                >
                  <MdShare className="w-full text-white h-full" />
                </div>
              </Tooltip>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default Desktop;
